<template>
  <div class="project-detail-view">
    <div class="project-detail-container" v-if="project">
      <div class="project-header">
        <router-link to="/projects" class="back-link">← Back to Projects</router-link>
        <h1>{{ project.title }}</h1>
        <p class="project-date">{{ project.date }}</p>
        
        <div v-if="project.externalLink" class="external-link">
          <a :href="project.externalLink" target="_blank">Visit Project →</a>
        </div>
      </div>

      <div class="project-detail-content">
        <div class="project-description" v-html="project.description"></div>
        
        <div class="project-images">
          <h2>Project Gallery</h2>
          <ProjectImage 
            v-for="(image, index) in project.images" 
            :key="index" 
            :image="image" 
          />
        </div>
      </div>
    </div>
    <div v-else class="not-found">
      <h1>Project Not Found</h1>
      <p>The project you're looking for doesn't exist or has been removed.</p>
      <router-link to="/projects" class="back-link">Return to Projects</router-link>
    </div>
  </div>
</template>

<script>
import ProjectImage from '@/components/projects/ProjectImage.vue';
import { getProjectBySlug } from '@/data/projects.js';

export default {
  name: 'ProjectDetailView',
  components: {
    ProjectImage
  },
  props: {
    slug: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      project: null
    }
  },
  created() {
    // Get the slug either from props or from route params
    const projectSlug = this.slug || this.$route.params.slug;
    this.loadProject(projectSlug);
  },
  methods: {
    loadProject(slug) {
      this.project = getProjectBySlug(slug);
      if (!this.project) {
        console.error(`Project with slug "${slug}" not found`);
      }
    }
  },
  watch: {
    // Update project data if the route changes
    '$route.params.slug': function(newSlug) {
      this.loadProject(newSlug);
    },
    // Also watch the prop if provided
    slug: function(newSlug) {
      if (newSlug) {
        this.loadProject(newSlug);
      }
    }
  }
}
</script>

<style scoped>
.project-detail-view {
  font-family: "Lustria", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #434342;
  min-height: 100vh;
  padding-bottom: 50px;
  color: white;
}

.project-detail-container {
  padding-top: 15px;
}

.project-header {
  margin: 30px auto;
  max-width: 50%;
  text-align: left;
}

.back-link {
  display: inline-block;
  margin-bottom: 20px;
  color: #FCBA03;
  text-decoration: none;
}

.back-link:hover {
  text-decoration: underline;
}

.project-date {
  font-style: italic;
  margin-bottom: 20px;
}

.external-link {
  margin-top: 15px;
}

.external-link a {
  display: inline-block;
  background: #FCBA03;
  color: #2c3e50 !important;
  padding: 10px 20px;
  border-radius: 4px;
  text-decoration: none;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.external-link a:hover {
  background: #ffcf4a;
  color: #2c3e50 !important;
}

.project-detail-content {
  margin: 0 auto;
  max-width: 50%;
  text-align: left;
}

.project-description {
  margin-bottom: 20px;
  line-height: 1.5;
}

.project-description p {
  margin-bottom: 10px;
  text-align: left;
  max-width: 100%;
}

.project-description ul {
  padding-left: 20px;
  margin-bottom: 15px;
}

.project-description li {
  margin-bottom: 8px;
  padding-bottom: 5px;
}

.project-images h2 {
  margin-bottom: 20px;
  text-align: center;
}

.not-found {
  text-align: center;
  padding: 50px 20px;
}

@media (max-width: 768px) {
  .project-header,
  .project-detail-content {
    max-width: 95%;
  }
}
</style>